import React from "react";
import { PauseOctagon, CreditCard } from "lucide-react";

/* Phase 9 — top-of-workspace red banner for suspended workspaces.
 * Renders only when workspace.suspended === true. Reads still work,
 * composer + message POST is blocked by the backend with HTTP 403.
 */
export default function SuspensionBanner({ workspace, onOpenBilling }) {
  if (!workspace?.suspended) return null;
  const reason = workspace.suspended_reason || "administrator";
  const isPaymentFailed = reason === "payment_failed";
  const isOwner = workspace.role === "owner";

  return (
    <div
      data-testid="suspension-banner"
      data-reason={reason}
      className="w-full px-4 sm:px-6 py-2.5 border-b border-[#A8351F]/55 bg-[#F8D6CE]"
    >
      <div className="max-w-5xl mx-auto flex items-center gap-3">
        <PauseOctagon
          size={14}
          className="text-[#A8351F] shrink-0"
          strokeWidth={2.2}
          aria-hidden
        />
        <p className="font-sans text-[13px] text-[#5E1812] flex-1 leading-snug">
          {isPaymentFailed ? (
            <>
              <strong className="font-medium">Workspace suspended.</strong>{" "}
              We couldn&apos;t charge the workspace&apos;s card after 3 attempts. New
              messages are blocked until the next invoice is paid.{" "}
              {isOwner ? "Update your payment method to restore access." : "Ask the workspace owner to update payment."}
            </>
          ) : (
            <>
              <strong className="font-medium">Workspace suspended.</strong>{" "}
              {reason !== "administrator"
                ? `Reason: ${reason}.`
                : "Contact a workspace administrator for details."}
            </>
          )}
        </p>
        {isPaymentFailed && isOwner ? (
          <button
            data-testid="suspension-banner-update-payment"
            onClick={onOpenBilling}
            className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md font-sans text-xs font-medium bg-[#A8351F] text-white hover:bg-[#8C3A1F] transition-colors shrink-0"
          >
            <CreditCard size={12} strokeWidth={2} />
            Update payment
          </button>
        ) : null}
      </div>
    </div>
  );
}
